export const CustomMetaTitle = (title: string): void => {
  document.title = title
}
